import { Card, Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Avatar, Box, Button, FormField, Typography, useCommonComponentContext } from "@maysoft/common-component-react";

import PopupUser from "./poupUser";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import Resources from "../../constants/resources";
import ChannelEditContainer from "../../containers/channel/edit";
import ChannelService from "../../services/message/Channel.service";
import ReactionService from "../../services/message/ReactionService";
import DialogInviteMember from "../CommunityMember/dialogInviteMember";
import ItemDetailPostComment from "../CommunityPost/itemDetailPostComment";
import PopupCreateUpdatePost from "../CommunityPost/popupCreateUpdatePost";
import DialogMemberInChannel from "../CommunityMember/dialogMemberInChannel";
import CommunityPostService from "../../services/message/CommunityPost.service";
import PopupItemDetailPostComment from "../CommunityPost/popupItemDetailPostComment";

import { IRecordPost } from "../../containers/post/usePost";
import { ChannelPagingType, Mode } from "../../constants/enums";
import { CommentProvider } from "../../providers/CommentProvider";
import { ICommunityPostDetail } from "../../containers/channel/useChannel";
import { useCommunityCommonContext } from "../../providers/CommunityCommonProvider";
import { ICodename, IPagedList, IReaction, IUserComment } from "../../commons/interfaces";



const CommunityChannelComponent = () => {
    const Strings = useStrings();

    const { axios, clientId, userInfo, tenantCode, serviceCode, onError, onHideLoading, onShowLoading } = useCommonComponentContext();

    const propsData = useCommunityCommonContext();

    const [mode, setMode] = useState<number>(Mode.Create);
    const [openPopupChannel, setOpenPopupChannel] = useState<boolean>(false);
    const [titleChannel, setTitleChannel] = useState<string | undefined>(undefined);
    const [channelIdDetail, setchannelIdDetail] = useState<string | undefined>(undefined);

    const [loading, setLoading] = useState(false);
    const [reactionIcons, setReactionIcons] = useState<IReaction[]>([]);
    const [dataGetPagePosts, setDataGetPagePosts] = useState<IPagedList<ICommunityPostDetail>>({
        hasNext: false,
        hasPrevious: false,
        pageSize: 0,
        totalPages: 0,
        totalCount: 0,
        currentPage: 0,
        items: [],
    });

    const [modelUserDrawer, setModelUserDrawer] = useState<{ open: boolean; data?: IUserComment }>({ open: false, data: undefined });
    const [modelPopupCreateUpdatePost, setModelPopupCreateUpdatePost] = useState<{ open: boolean; data?: IRecordPost }>({
        open: false,
        data: undefined,
    });
    const [modelDialogPostComment, setModelDialogPostComment] = useState<{ open: boolean; data?: ICommunityPostDetail }>({
        open: false,
        data: undefined,
    });

    const listChannels = useMemo(
        () => [...(propsData.listChannels || [])].map((item) => ({ code: item.id, name: item.name } as ICodename)),
        [propsData.listChannels]
    );

    const channelCurent = useMemo(
        () => [...(propsData.listChannels || [])].find((el) => el.id === propsData.channelId),
        [propsData.channelId, propsData.listChannels]
    );

    useEffect(() => {
        const getAllReactionIcon = async () => {
            try {
                const result = await ReactionService.getAll();
                setReactionIcons(result);
            } catch (error) {
                setReactionIcons([]);
            }
        };
        getAllReactionIcon();
    }, []);

    useEffect(() => {
        (async () => {
            onShowLoading();

            setDataGetPagePosts({
                hasNext: false,
                hasPrevious: false,
                pageSize: 0,
                totalPages: 0,
                totalCount: 0,
                currentPage: 0,
                items: [],
            });

            if (Helpers.isNullOrEmpty(propsData.channelId) || propsData.channelId === "create") {
                setMode(Mode.Create);
                setOpenPopupChannel(true);
                setchannelIdDetail(undefined);
                setTitleChannel(Strings.CHANNEL.TITLE_CREATE_VIEW);
            } else {
                setMode(Mode.Update);
                setchannelIdDetail(propsData.channelId);
                setTitleChannel(Strings.CHANNEL.TITLE_UPDATE_VIEW);

                try {
                    const result = await ChannelService.getDetail(propsData.channelId);

                    if (result.isMember) {
                        await getPagedPostByChannelId({
                            idChannel: propsData.channelId,
                            pageNumber: 1,
                        });
                    } else {
                        joinChannel(propsData.channelId);
                    }
                } catch (error) {
                    onHideLoading();
                    const err = Helpers.renderExceptionError(error);
                    onError(err);
                }
            }

            onHideLoading();
        })();
    }, [propsData.channelId, propsData.communityId]);

    const joinChannel = (id: string) => {
        Helpers.showConfirmAlert(
            Strings.CHANNEL.CONFIRM_JOIN_CHANNEL,
            async () => {
                try {
                    const result = await ChannelService.join(id);
                    if (result.statusCode === 200) {
                        await getPagedPostByChannelId({
                            idChannel: propsData.channelId,
                            pageNumber: 1,
                        });
                    }
                } catch (error) { }
            },
            () => {
                propsData.onGoBack && propsData.onGoBack();
            },
            Strings.Common.JOIN,
            Strings.Common.REJECT
        );
    };

    const getPagedPostByChannelId = async (req: { idChannel?: string; pageNumber?: number }) => {
        try {
            setLoading(true);

            const resultGetPage = await CommunityPostService.getPaged({
                channelId: req?.idChannel,
                pageSize: 2,
                pageNumber: req?.pageNumber || 1,
            });

            setDataGetPagePosts((prev) => ({
                ...prev,
                ...resultGetPage,
                items: [...prev.items, ...resultGetPage.items],
            }));

            setLoading(false);
        } catch (error) {
            setLoading(false);
            onHideLoading();
            const err = Helpers.renderExceptionError(error);
            onError(err);
        }
    };

    // Box loading
    const renderBoxLoading = () => {
        let value = "";
        if ([...(dataGetPagePosts?.items || [])].length === 0) {
            value = Strings.Common.NO_DATA;
        } else {
            if (dataGetPagePosts.totalCount !== [...(dataGetPagePosts?.items || [])].length) {
                value = Strings.Common.LOADING;
            } else {
                value = "";
            }
        }

        return (
            <Box
                sx={{
                    width: "100%",
                    padding: "1rem",
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "center",
                    height: [...(dataGetPagePosts?.items || [])].length === 0 ? "90%" : undefined,
                }}
            >
                {loading ? (
                    <Typography variant="caption" fontWeight="bold">
                        {Strings.Common.LOADING}
                    </Typography>
                ) : (
                    <Typography variant="caption" fontWeight="bold">
                        {value}
                    </Typography>
                )}
            </Box>
        );
    };

    return (
        <CommentProvider
            value={{
                axios: axios,
                clientId: clientId,
                tenantCode: tenantCode,
                serviceCode: serviceCode,
                organizationId: userInfo?.userProfile?.organizationId,
                userLogin: {
                    role: undefined,
                    avatarUrl: userInfo?.userProfile?.avatarUrl,
                    avatarId: userInfo?.userProfile?.avatarId,
                    userName: userInfo?.userProfile?.userName,
                    fullName: userInfo?.userProfile?.fullName,
                    userId: userInfo?.userProfile?.identityId,
                },

                isManager: false,
                hiddenComment: false,
                reactionIcons: reactionIcons,
                referenceId: modelDialogPostComment?.data?.id || "",

                onClickShowProfile(data) {
                    setModelUserDrawer({
                        data: data,
                        open: !Helpers.isNullOrEmpty(data.userId),
                    });
                },
            }}
        >
            {/* View Create Update Channel */}
            {!Helpers.isNullOrEmpty(propsData.channelId) && (
                <ChannelEditContainer
                    mode={mode}
                    title={titleChannel}
                    communityId={propsData.communityId}
                    onChangeMode={(value) => {
                        setMode(value);
                    }}
                    id={channelIdDetail === "create" ? undefined : channelIdDetail}
                    onCallBack={() => {
                        Helpers.isFunction(propsData.onCallBack) && propsData.onCallBack();
                    }}
                    dataPopup={{
                        openPopup: openPopupChannel,
                        isShowPopup: !Helpers.isNullOrEmpty(propsData.channelId) && propsData.channelId !== "create",
                        onClosePopup() {
                            setTitleChannel("");
                            setMode(Mode.Create);
                            setOpenPopupChannel(false);
                        },
                    }}
                />
            )}

            {/* View Popup User Profile  */}
            <PopupUser
                dataUser={modelUserDrawer?.data}
                openDrawer={modelUserDrawer?.open}
                onCloseDrawer={() => {
                    setModelUserDrawer({ ...modelUserDrawer, open: false });
                }}
            />

            {propsData.channelId !== "create" && (
                <>
                    {/* Popup Create or Update Post */}
                    <PopupCreateUpdatePost
                        channelId={channelIdDetail}
                        listChannels={listChannels || []}
                        open={modelPopupCreateUpdatePost?.open}
                        dataDetailPost={modelPopupCreateUpdatePost?.data}
                        onAction={(isCreate, data) => {
                            let newListTemp = [...(dataGetPagePosts?.items || [])];

                            if (isCreate) {
                                newListTemp.push(data);
                            } else {
                                const indexTemp = newListTemp.findIndex((item) => item.id === data.id);
                                if (indexTemp !== -1) {
                                    newListTemp[indexTemp] = data;
                                }
                            }

                            setDataGetPagePosts({ ...dataGetPagePosts, items: newListTemp });

                            setModelPopupCreateUpdatePost({ open: false, data: undefined });
                        }}
                        onClose={() => {
                            setModelPopupCreateUpdatePost({ open: false, data: undefined });
                        }}
                    />

                    {/* View Popup Item Detail Post Comment */}
                    <PopupItemDetailPostComment
                        openPopup={modelDialogPostComment.open}
                        dataDetailPost={modelDialogPostComment?.data}
                        onClose={(data) => {
                            let newListTemp = [...(dataGetPagePosts?.items || [])];

                            const indexTemp = newListTemp.findIndex((item) => item.id === data.id);

                            if (indexTemp !== -1) {
                                newListTemp[indexTemp] = data;
                            }

                            setDataGetPagePosts({ ...dataGetPagePosts, items: newListTemp });

                            setModelDialogPostComment({ open: false, data: undefined });
                        }}
                        onShowUserProfile={(data) => {
                            setModelUserDrawer({
                                data: data,
                                open: !Helpers.isNullOrEmpty(data?.userId),
                            });
                        }}
                        onEditPost={(data) => {
                            setModelPopupCreateUpdatePost({
                                open: true,
                                data: data,
                            });
                        }}
                    />

                    <InfiniteScroll
                        style={{ backgroundColor: "transparent" }}
                        dataLength={[...(dataGetPagePosts.items || [])].length}
                        hasMore={dataGetPagePosts.hasNext}
                        loader={renderBoxLoading()}
                        next={async () => {
                            if (dataGetPagePosts.hasNext) {
                                getPagedPostByChannelId({
                                    idChannel: channelIdDetail,
                                    pageNumber: (dataGetPagePosts.currentPage || 0) + 1,
                                });
                            }
                        }}
                    >
                        <Grid container spacing={2}>
                            {/* Cart Title Channel */}
                            <Grid item xs={12}>
                                <Card>
                                    <Box display="flex" flexWrap="wrap" padding="16px 20px" alignItems="center" justifyContent="space-between">
                                        <Box display="flex" flexWrap="wrap" alignItems="center">
                                            <img
                                                alt=""
                                                style={{
                                                    width: "50px",
                                                    height: "50px",
                                                    marginRight: "16px",
                                                    borderRadius: "8px",
                                                }}
                                                src={channelCurent?.avatarImageUrl || Resources.IMG_THUMBNAIL}
                                            />
                                            <Typography variant="body1" color="secondary" fontWeight="bold">
                                                {channelCurent?.name}
                                            </Typography>
                                        </Box>

                                        <Box display="flex" flexDirection="row" flexWrap="wrap">
                                            {/* Dialog Invite Member In Channel */}
                                            <Box mx={2} display="flex">
                                                <DialogInviteMember
                                                    type={ChannelPagingType.Channel}
                                                    roleList={[]}
                                                    listChannels={[]}
                                                    listCommunitys={[]}
                                                    channelId={propsData.channelId}
                                                    communityCode={propsData.communityCode}
                                                />
                                            </Box>
                                            {/* Dialog Member In Channel */}
                                            <Box mx={2} display="flex">
                                                <DialogMemberInChannel
                                                    type={ChannelPagingType.Channel}
                                                    discussionGroupId={propsData.channelId || ""}
                                                    totalMembers={channelCurent?.totalMember || 0}
                                                />
                                            </Box>
                                            {/* Button Edit Channel */}
                                            {
                                                <Button
                                                    sx={{ ml: 2 }}
                                                    onClick={() => {
                                                        setMode(Mode.Update);
                                                        setchannelIdDetail(propsData.channelId);
                                                        setTitleChannel(Strings.CHANNEL.TITLE_UPDATE_VIEW);
                                                        setOpenPopupChannel(true);
                                                    }}
                                                >
                                                    {Strings.Common.EDIT}
                                                </Button>
                                            }
                                        </Box>
                                    </Box>
                                </Card>
                            </Grid>

                            {/* Card Hover Add Post */}
                            <Grid item xs={12}>
                                <Card>
                                    <Box p={"16px 20px"} display="flex" alignItems="center">
                                        <Box
                                            sx={{ "&:hover": { cursor: "pointer" } }}
                                            onClick={() => {
                                                setModelUserDrawer({
                                                    open: true,
                                                    data: {
                                                        role: undefined,
                                                        userId: userInfo?.userProfile?.identityId,
                                                        fullName: userInfo?.userProfile?.fullName,
                                                        userName: userInfo?.userProfile?.userName,
                                                        avatarId: userInfo?.userProfile?.avatarId,
                                                        avatarUrl: userInfo?.userProfile?.avatarUrl,
                                                    },
                                                });
                                            }}
                                        >
                                            <Avatar
                                                src={userInfo?.userProfile?.avatarUrl}
                                                style={{ border: "1px #344767 solid", marginRight: "16px" }}
                                                text={userInfo?.userProfile?.fullName || userInfo?.userProfile?.userName}
                                            />
                                        </Box>
                                        <FormField
                                            value=""
                                            defaultValue=""
                                            variant="outlined"
                                            focused={false}
                                            autoFocus={false}
                                            placeholder={Strings.CHANNEL.WRITE_A_POST}
                                            onClick={() => {
                                                setModelPopupCreateUpdatePost({
                                                    open: true,
                                                    data: undefined,
                                                });
                                            }}
                                        />
                                    </Box>
                                </Card>
                            </Grid>

                            {/* List Item Post in Channel */}
                            {[...(dataGetPagePosts.items || [])].map((item) => (
                                <Grid item xs={12} key={item.id}>
                                    <Card>
                                        <ItemDetailPostComment
                                            isDetail={false}
                                            dataDetail={item}
                                            onShowUserProfile={(data) => {
                                                setModelUserDrawer({
                                                    data: data,
                                                    open: !Helpers.isNullOrEmpty(data?.userId),
                                                });
                                            }}
                                            onEditPost={(data) => {
                                                setModelPopupCreateUpdatePost({
                                                    open: true,
                                                    data: data,
                                                });
                                            }}
                                            onClickBox={(data) => {
                                                setModelDialogPostComment({
                                                    open: true,
                                                    data: data,
                                                });
                                            }}
                                            onCallBack={(data, isDelete) => {
                                                let newListTemp = [...(dataGetPagePosts?.items || [])];

                                                if (isDelete) {
                                                    newListTemp = newListTemp.filter((item) => item.id !== data.id);
                                                } else {
                                                    const indexTemp = newListTemp.findIndex((item) => item.id === data.id);
                                                    if (indexTemp !== -1) {
                                                        newListTemp[indexTemp] = data;
                                                    }
                                                }

                                                setDataGetPagePosts({ ...dataGetPagePosts, items: newListTemp });
                                            }}
                                        />
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </InfiniteScroll>
                </>
            )}
        </CommentProvider>
    );
};

export default CommunityChannelComponent;
